export function okendoError(message) {
    return `Okendo: ${message}`;
}
export function widgetConfigurationError(widgetName, message) {
    return okendoError(`${widgetName} error: ${message}`);
}
export function widgetMetafieldError(widgetName, metafieldName) {
    return okendoError(`${widgetName} error: Failed to retrieve metafield '${metafieldName}'.`);
}
